import request from '@/utils/httpRequest'

export default class PlanService {
  queryPlanById(id) {
    return request({
      url: '/patrol/wuyePatrolPlan/queryById',
      method: 'get',
      params: { id: id }
    })
  }

  startFlow(params) {
    return request({
      url: '/patrol/wuyePatrolPlan/startFlow',
      method: 'post',
      data: params
    })
  }
}
